import React, { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import IconPicker from '../../IconPicker/IconPicker';

import './_YatLinkIcon.scss';

type Props = {
    linkEmoji: string;
    editable: boolean;
    onEmojiSelect: (emoji: string) => void;
    debounce: number;
    onBlur: () => void;
    onPickerOpened: (open: boolean) => void;
};

export default function YatLinkIcon({ linkEmoji, editable, onEmojiSelect, onBlur, debounce, onPickerOpened }: Props) {
    const { t } = useTranslation('yat_page');
    const [showPicker, setShowPicker] = useState<boolean>(false);
    const [selectedEmoji, setSelectedEmoji] = useState<string>(linkEmoji);
    const btnRef = useRef<HTMLDivElement>(null);
    const pickerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                btnRef.current &&
                !btnRef.current.contains(event.target) &&
                pickerRef.current &&
                !pickerRef.current.contains(event.target)
            ) {
                setShowPicker(false);
                onPickerOpened(false);
                onBlur();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [btnRef, setShowPicker, onPickerOpened, onBlur]);

    function handleEmojiSelection(emoji: string): void {
        onEmojiSelect(emoji);
        setSelectedEmoji(emoji);
        togglePicker(false);
    }
    const togglePicker = (toggle: boolean) => {
        if (toggle) {
            clearTimeout(debounce);
        }
        setShowPicker(toggle);
        onPickerOpened(toggle);
    };

    return (
        <div className="YatLinkIcon" ref={btnRef}>
            {editable ? (
                <div
                    className="icon-button"
                    onClick={() => {
                        togglePicker(!showPicker);
                    }}
                >
                    <span className="link-emoji" role="img" aria-label={t('emoji_icon')}>
                        {selectedEmoji}
                    </span>
                </div>
            ) : (
                <div className="icon-button">
                    <span className="link-emoji" role="img" aria-label={t('emoji_icon')}>
                        {selectedEmoji}
                    </span>
                </div>
            )}

            {showPicker && (
                <div className="emoji-picker" ref={pickerRef}>
                    <IconPicker onSelect={handleEmojiSelection} />
                </div>
            )}
        </div>
    );
}
